// extracted by mini-css-extract-plugin
export default {"loading":"Urls_loading__z9MR6","wrapper":"Urls_wrapper__b-M4P","id":"Urls_id__zXLaX"};